import React, { useContext } from "react";
import CenterChoices from "../../../components/CenterChoices";
import Lang from "../../../components/Lang";
import Text from "../../../components/Text";
import { CustomersContext, StudentsContext,ClassesContext } from "../../../../../Context";
import mut from "../../../hooks/mut";
import Rating from "../../../components/Rating";
import { Chip } from "@mui/material";
import PhoneNumber from "../../../components/PhoneNumber";

export default function SalesInfo(props) {
  const {  customer, setCustomer} = props;
  let { customers } = useContext(CustomersContext)
  const { students } = useContext(StudentsContext)
  const { classes} = useContext(ClassesContext)
  const [search, setSearch] = React.useState("");

  const deleteFriend = (e, id, name) => {
    let friends = props.customer.friends.filter((f) => f._id !== id);
    props.customer.friends = friends;
    props.setCustomer(props.customer);
    props.updateCustomer();
  };
  const addFriend = async (friend) => {
    let friends = [...customer.friends, friend]
    setCustomer({ ...customer, friends });
    await mut("post", `/customers/${customer._id}/update`,{friends});
    setSearch("");
  };

  customers = addStudentsToCustomers(customers,students,classes)

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      ></div>
      <CenterChoices
        value={customer.marketingSource}
        setValue={(marketingSource) => {
          setCustomer((prev) => ({ ...prev, marketingSource }));
        }}
        centerField="marketingSources"
        label={<Lang w="marketingSource" />}
        url={`/customers/${customer._id}/update`}
        field="marketingSource"
        style={{ marginBottom: 5 }}
      />

      <div
        style={{
          border: "1px solid #ccc",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 10,
          borderRadius: 10,
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <h3>
            <Lang w="learning" />
          </h3>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Text
            value={customer.reasonForLearning}
            label={<Lang w="reasonForLearning" />}
            setValue={(reasonForLearning) =>
              setCustomer({ ...customer, reasonForLearning })
            }
            url={`/customers/${customer._id}/update`}
            field="reasonForLearning"
          />
          <Text
            value={customer.problemsWithChildren}
            label={<Lang w="problemsWithTheCustomersChildren" />}
            setValue={(problemsWithChildren) =>
              setCustomer({ ...customer, problemsWithChildren })
            }
            url={`/customers/${customer._id}/update`}
            field="problemsWithChildren"
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>{<Lang w="customersEnglishKnowledge" />}</div>
            <Rating
              value={customer.englishKnowledge}
              setValue={(englishKnowledge) =>
                setCustomer({ ...customer, englishKnowledge })
              }
              url={`/customers/${customer._id}/update`}
              field="englishKnowledge"
            />
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #ccc",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 10,
          borderRadius: 10,
        }}
      >
        <div style={{ fontSize: 16, marginBottom: 10 }}>
          <h3>
            <Lang w="financial" />
          </h3>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ display: "flex" }}>
            <Text
              value={customer.dadsJob}
              label={<Lang w="fathersJob" />}
              setValue={(dadsJob) => setCustomer({ ...customer, dadsJob })}
              url={`/customers/${customer._id}/update`}
              field="dadsJob"
            />
            <Text
              value={customer.jobs !== undefined ? customer.jobs[1] : ""}
              label={<Lang w="mothersJob" />}
              setValue={(mumsJob) => setCustomer({ ...customer, mumsJob })}
              url={`/customers/${customer._id}/update`}
              field="mumsJob"
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ marginRight: 20 }}>
              <Lang w="householdIncome" />
            </div>
            <Rating
              value={customer.income}
              setValue={(income) => setCustomer({ ...customer, income })}
              url={`/customers/${customer._id}/update`}
              field="income"
            />
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #ccc",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 10,
          borderRadius: 10,
        }}
      >
        {
          // edit from here
        }
        <div style={{ fontSize: 11 }}>
          <Lang w="friendsAtTheCenter"/>
          <div style={{ display: "flex" }}>
            <Text
              label="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search !== "" ? (
              <div>
                {customers
                  .filter(
                    (c) =>
                      (c.name &&
                        c.name
                          .toLowerCase()
                          .includes(search.toLocaleLowerCase())) ||
                      (c.phone && c.phone.includes(search))
                  )
                  .slice(0, 10)
                  .map((c) => (
                    <div style={{ fontSize: 14, marginLeft: 10 }}>
                      <CustomerSearch customer={c} addFriend={addFriend} />
              
                     {/*  <IconButtonHT action={(e) => addFriend(e, c._id, c.name, c.phone)} icon="add" /> */}
                    </div>
                  ))}
              </div>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginTop: 10 }}>
            {customer.friends.map((f) => (
              <Chip
                label={f.name ? f.name : f.phone}
                onDelete={(e) => deleteFriend(e, f._id, f.name)}
                sx={{ marginRight: 1 }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function CustomerSearch({ customer,addFriend }) {
 
  return (
    <div
      className="customer-search-choice"
      style={{
        padding: 5,
        borderBottom: "1px solid #ccc",
        cursor: "pointer",
    
      }}
      onClick={()=>addFriend({_id: customer._id, name: customer.name})}
    >
      <div>
        {customer.name || "No name"}, <PhoneNumber value={customer.phone} />
      </div>
      <div style={{ display: "flex", color: "#888", gap:5 }}>
        {customer.students.map((s) => (
          <div>
            {s.name} {s.classNames.toString()}
          </div>
        ))}
      </div>
    </div>
  );
}


function addStudentsToCustomers(customers, students, classes) {
  for (let customer of customers) {
    customer.students = students.filter(s => s.customer === customer._id)
    for (let student of customer.students) {
      student.classNames = []
      for (let classId of student.classes) {
        const htClass = classes.find(c => c._id === classId)
        if(htClass) student.classNames.push(htClass.name)
        }
    }
  }
  return customers
}